/* eslint-disable i18next/no-literal-string */
import { getPortalAssetsUrl } from 'common/utilities/AssetsPath';
import { pageDataService } from 'common/utilities/PageDataService';
import { getLocale } from 'i18n';
import i18next from 'i18next';

import type { IWindow } from '@ms-ofb/officebrowserfeedback/lib/Window/Window';

import '@ms-ofb/officebrowserfeedback/scripts/officebrowserfeedback';

export type FeedbackType = 'Bug' | 'Smile' | 'Suggestion';

// typed with OfficeBrowserFeedback property
declare const window: IWindow;

const getFeedbackAssetUrl = (path: string): string => `${getPortalAssetsUrl()}feedback/${path}`;

export function ocvFeedbackLoadAndInitialize(): void {
  window.OfficeBrowserFeedback.initOptions = {
    appId: pageDataService.isProdEnvironment() ? 2479 : 50047, // 2479 - Prod, 50047 - Int
    stylesUrl: getFeedbackAssetUrl('officebrowserfeedback.css'), // Replace by where you have hosted the .css
    intlUrl: getFeedbackAssetUrl('smileStrings/'), // Default strings. For Single form we need to use setUIStrings before each render.
    locale: getLocale(),
    environment: pageDataService.isProdEnvironment() ? 0 : 1, // 0 - Prod, 1 - Int
    onError: (error: string) => {
      console.error(`SDK encountered an error: ${error}`);
    },
    applicationGroup: {
      appData: '{"AppData1":"AppData1 Value", "AppData2":"AppData2 Value"}', // TODO: Update with our data
    },
    telemetryGroup: {
      audienceGroup: 'TestAudienceGroup',
    },
    customResourcesSetExternally: 2, // Set the OCV strings explicitly
  };
}

const { t } = i18next;
function getCommentPlaceholder(type: string) {
  switch (type) {
    case 'Bug':
      return [t('OcvFeedback.Feedback_Bug.Title'), t('OcvFeedback.Feedback_Bug.CommentPlaceholder')];
    case 'Smile':
      return [t('OcvFeedback.Feedback_Like.Title'), t('OcvFeedback.Feedback_Like.CommentPlaceholder')];
    default:
      return [t('OcvFeedback.Feedback_Suggestion.Title'), t('OcvFeedback.Feedback_Suggestion.CommentPlaceholder')];
  }
}

export function renderFeedbackForm(feedbackType: FeedbackType): void {
  const ocvType = {
    Bug: 'Bug',
    Suggestion: 'Frown',
    Smile: 'Smile',
  }[feedbackType];

  const [tempTitle, tempCommentPlaceHolder] = getCommentPlaceholder(ocvType);

  window.OfficeBrowserFeedback.setUiStrings({
    PrivacyStatement: t('OcvFeedback.PrivacyStatement'),
    Form: {
      CommentPlaceholder: tempCommentPlaceHolder,
      EmailPlaceholder: t('OcvFeedback.EmailPlaceholder'),
      ScreenshotLabel: t('OcvFeedback.ScreenshotLabel'),
      Submit: t('OcvFeedback.Submit'),
      Cancel: t('OcvFeedback.Cancel'),
      EmailCheckBoxLabel: t('OcvFeedback.EmailCheckBoxLabel'),
    },
    SingleForm: {
      Title: tempTitle,
    },
    ThanksPanel: {
      Title: t('OcvFeedback.ThanksPanel.Title'),
      AppreciateText: t('OcvFeedback.ThanksPanel.AppreciateText'),
      Close: t('OcvFeedback.ThanksPanel.Close'),
    },
  });
  window.OfficeBrowserFeedback.singleFeedback(ocvType, {}).catch((error: unknown) => {
    console.error(`${ocvType} feedback failed: ${error}`);
  });
}
